<script>
import Layout from "@/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Donutchart from "@/views/charts/chartjs/DonutChart.vue";

/**
 * Dashboard Component
 */
export default {
  data() {
    return {
      series: [
        {
          name: "11PM - 12AM",
          data: [66, 34, 73, 31, 16, 26, 72],
        },
        {
          name: "10PM- 11PM",
          data: [33, 35, 62, 71, 59, 58, 14],
        },
        {
          name: "9PM- 10PM",
          data: [50, 40, 22, 18, 8, 21, 7],
        },
        {
          name: "8PM- 9PM",
          data: [68, 13, 36, 20, 6, 4, 49],
        },
        {
          name: "7PM- 8PM",
          data: [16, 26, 72, 43, 33, 35, 62],
        },
        {
          name: "6PM- 7PM",
          data: [53, 5, 51, 29, 27, 10, 28],
        },
        {
          name: "5PM- 6PM",
          data: [56, 39, 1, 54, 45, 46, 30],
        },
        {
          name: "4PM- 5PM",
          data: [70, 65, 50, 34, 50, 27, 18],
        },
        {
          name: "3PM- 4PM",
          data: [11, 17, 1, 65, 69, 34, 50],
        },
        {
          name: "2PM- 3PM",
          data: [70, 65, 69, 34, 50, 43, 36],
        },
        {
          name: "1PM- 2PM",
          data: [13, 23, 20, 8, 13, 27, 70],
        },
        {
          name: "12PM- 1PM",
          data: [11, 57, 15, 15, 71, 14, 11],
        },
        {
          name: "11AM - 12PM",
          data: [44, 55, 41, 67, 22, 43, 36],
        },
        {
          name: "10AM - 11AM",
          data: [73, 23, 20, 5, 13, 57, 18],
        },
        {
          name: "9AM - 10AM",
          data: [51, 17, 15, 45, 21, 14, 71],
        },
        {
          name: "8AM - 9AM",
          data: [44, 55, 71, 64, 22, 53, 36],
        },
        {
          name: "7AM - 8AM",
          data: [3, 23, 45, 8, 53, 7, 18],
        },
        {
          name: "6AM - 7AM",
          data: [41, 17, 55, 15, 21, 74, 11],
        },
        {
          name: "5AM - 6AM",
          data: [44, 55, 41, 67, 22, 43, 36],
        },
        {
          name: "4AM - 5AM",
          data: [13, 23, 20, 8, 13, 27, 68],
        },
        {
          name: "3AM - 4AM",
          data: [11, 17, 15, 15, 21, 74, 11],
        },
        {
          name: "2AM - 3AM",
          data: [44, 55, 41, 67, 22, 43, 36],
        },
        {
          name: "1AM - 2AM",
          data: [13, 23, 20, 8, 13, 27, 68],
        },
        {
          name: "12AM - 1AM",
          data: [11, 17, 15, 15, 21, 74, 11],
        },
      ],
      chartOptions: {
        chart: {
          stacked: true,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: true,
          },
        },
        plotOptions: {
          heatmap: {
            shadeIntensity: 0.5,
            radius: 0,
            useFillColorAsStroke: true,
            colorScale: {
              ranges: [
                {
                  from: -30,
                  to: 5,
                  name: "Very low",
                  color: "#32CD32",
                },
                {
                  from: 6,
                  to: 20,
                  name: "Low",
                  color: "#90EE90",
                },
                {
                  from: 21,
                  to: 45,
                  name: "Medium",
                  color: "#98FB98",
                },
                {
                  from: 46,
                  to: 55,
                  name: "High",
                  color: "#FF7F50",
                },
                {
                  from: 56,
                  to: 65,
                  name: "Very high",
                  color: "#FF6347",
                },
                {
                  from: 66,
                  to: 75,
                  name: "Extreme",
                  color: "#FF0000",
                },
              ],
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
            "Sunday",
          ],
        },
        // colors: [
        //   "#556ee6",
        //   "#f1b44c",
        //   "#34c38f",
        //   "#556ee6",
        //   "#f1b44c",
        //   "#34c38f",
        //   "#556ee6",
        // ],
        // fill: {
        //   opacity: 1,
        // },
        grid: {
          padding: {
            right: 20,
          },
        },
      },
    };
  },
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Donutchart,
  },
};
</script>

<template>
  <Layout>
    <PageHeader
      title="Management"
      :items="items"
    />
    <div
      class="row"
      style="text-align: center"
    >
      <div class="col-4">
        <h4 style="text-align: center">VEHICLE CLASS</h4>
        <Donutchart />
      </div>
      <div class="col-8">
        <h4 style="text-align: center">HEAT MAP</h4>
        <apexchart
          type="heatmap"
          height="450"
          :series="series"
          :options="chartOptions"
        ></apexchart>
      </div>
    </div>
  </Layout>
</template>
